import type { TeamMember } from '@api'

import type { ChatterTrackingUserEntry } from '@/modules/tracking/chatter-tracking/service/chatter-tracking-service.ts'

export function getActivityStateById(
  membersOrEntries: TeamMember[] | ChatterTrackingUserEntry[],
  id: number,
) {
  const memberOrEntry = membersOrEntries.find((entry) => entry.userId === id)

  return memberOrEntry?.activityState || 'OFFLINE'
}
